const ANALYTICS_SCRIPT_ID = "proxy-divorce-gtag"
const PENDING_EVENTS_ID = "analytics-events"

function measurementId() {
  return document.body?.dataset.gaMeasurementId
}

function initializeGtag(id) {
  window.dataLayer = window.dataLayer || []
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments) }

  if (!document.getElementById(ANALYTICS_SCRIPT_ID)) {
    const script = document.createElement("script")
    script.id = ANALYTICS_SCRIPT_ID
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`
    document.head.appendChild(script)
  }

  window.proxyDivorceGaConfigured = window.proxyDivorceGaConfigured || {}
  if (!window.proxyDivorceGaConfigured[id]) {
    window.gtag("js", new Date())
    window.gtag("config", id, { send_page_view: false })
    window.proxyDivorceGaConfigured[id] = true
  }
}

function sendPageView(id) {
  const pageLocation = window.location.href
  if (window.proxyDivorceLastPageView === pageLocation) return

  const params = {
    page_title: document.title,
    page_location: pageLocation,
    page_path: `${window.location.pathname}${window.location.search}`
  }
  if (document.body?.dataset.analyticsIgnoreReferrer === "true") params.ignore_referrer = true

  window.gtag("event", "page_view", params)
  window.proxyDivorceLastPageView = pageLocation
}

function sendPendingEvents() {
  const node = document.getElementById(PENDING_EVENTS_ID)
  if (!node) return

  try {
    const events = JSON.parse(node.textContent)
    events.forEach((event) => window.gtag("event", event.name, event.params || {}))
  } catch (error) {
    console.warn("Unable to parse analytics events", error)
  } finally {
    node.remove()
  }
}

function setAnalyticsCookie(name, value, maxAge) {
  if (!value) return

  const secure = window.location.protocol === "https:" ? "; Secure" : ""
  document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}`
}

function captureGaIdentifiers(id) {
  window.gtag("get", id, "client_id", (value) => setAnalyticsCookie("pd_ga_client_id", value, 63_072_000))
  window.gtag("get", id, "session_id", (value) => setAnalyticsCookie("pd_ga_session_id", value, 1_800))
}

function eventParams(form) {
  const params = {}
  if (form.dataset.analyticsValue) params.value = Number(form.dataset.analyticsValue)
  if (form.dataset.analyticsCurrency) params.currency = form.dataset.analyticsCurrency
  if (form.dataset.analyticsItem) {
    params.items = [{ item_id: form.dataset.analyticsItem, item_name: form.dataset.analyticsItem }]
  }
  return params
}

function handleTrackedSubmit(event) {
  const form = event.target.closest("form[data-analytics-event]")
  if (!form || form.dataset.analyticsSubmitting === "true") return

  const id = measurementId()
  if (!id || typeof window.gtag !== "function") return

  event.preventDefault()
  form.dataset.analyticsSubmitting = "true"

  let submitted = false
  const continueSubmission = () => {
    if (submitted) return

    submitted = true
    HTMLFormElement.prototype.submit.call(form)
  }

  window.gtag("event", form.dataset.analyticsEvent, {
    ...eventParams(form),
    transport_type: "beacon",
    event_callback: continueSubmission,
    event_timeout: 700
  })
  window.setTimeout(continueSubmission, 750)
}

function setupAnalytics() {
  const id = measurementId()
  if (!id) return

  initializeGtag(id)
  sendPageView(id)
  sendPendingEvents()
  captureGaIdentifiers(id)
}

if (!window.proxyDivorceAnalyticsListenersInstalled) {
  document.addEventListener("turbo:load", setupAnalytics)
  document.addEventListener("submit", handleTrackedSubmit)
  window.proxyDivorceAnalyticsListenersInstalled = true
}
